import { LoginInfo, ApiBase, ApiResponse } from 'types';

const BASE_URL = 'auth';

export class AuthApi extends ApiBase {
  public async login(email: string, password: string): Promise<ApiResponse<LoginInfo>> {
    const response = await this.apiClient.post(`${BASE_URL}/login`, {
      email,
      password,
    });

    return response.data;
  }

  public async forgotPassword(email: string): Promise<ApiResponse<any>> {
    const response = await this.apiClient.post(`${BASE_URL}/forgot-password`, {
      email,
    });

    return response.data;
  }

  public async resetPassword(token: string, password: string, confirmPassword: string): Promise<ApiResponse<any>> {
    const response = await this.apiClient.post(`${BASE_URL}/reset-password`, {
      token,
      password,
      confirmPassword,
    });

    return response.data;
  }
}
